<template>
  <portal :to="portalId">
    <div
      class="lg:flex w-full financial-summary"
      :class="{
        'has-error': error && Object.keys(error).length
      }"
    >
      <div class="financial-summary-heading lg:w-1/3 content-title ">
        <h3 class="mb-0" v-html="input.label + ' Financial Summary'" />
        <p v-if="input.instructions">
          {{ input.instructions }}
        </p>
        <template v-if="error && Object.keys(error).length">
          <template v-for="(arr, arri) in error">
            <p
              v-for="(val, i) in arr"
              :key="arri + '.' + i"
              class="text-negative-600"
            >
              {{ val }}
            </p>
          </template>
        </template>
      </div>
      <div class="lg:w-2/3 lg:pl-8 lg:pt-3 content-body">
        <div class="-mx-6 -mb-8 flex flex-wrap">
          <input-default
            :review-mode="reviewMode"
            :input="fields.requested_grant"
            :parent-field="parentField"
            :application-value="applicationValue.requested_grant"
            @update:input="updateField"
          />
          <input-default
            :review-mode="reviewMode"
            :input="fields.contribution"
            :parent-field="parentField"
            :application-value="applicationValue.contribution"
            @update:input="updateField"
          />
          <input-default
            :review-mode="reviewMode"
            :input="fields.total_project_cost"
            :parent-field="parentField"
            :application-value="applicationValue.total_project_cost"
            @update:input="updateField"
          />
        </div>
      </div>
    </div>
  </portal>
</template>

<script>
import { inputHelperMixin } from "../../mixins/inputHelper";
export default {
  name: "InputConsortium",
  mixins: [inputHelperMixin],
  data() {
    return {
      values: {
        requested_grant: 0,
        contribution: 0,
        total_project_cost: 0
      },
      fields: {
        requested_grant: {
          type: "number",
          key: "requested_grant",
          label: "Request Grant",
          attributes: {
            prepend: "£",
            default: 0,
            placeholder: "50,000",
            required: true
          },
          validation: {
            min: 0,
            max: 250000
          },
          wrapper: {
            width: "1/3"
          }
        },
        contribution: {
          type: "number",
          key: "contribution",
          label: "Contribution",
          attributes: {
            prepend: "£",
            default: 0,
            placeholder: "50,000",
            required: true
          },
          validation: {
            min: 0,
            max: 250000
          },
          wrapper: {
            width: "1/3"
          }
        },
        total_project_cost: {
          type: "number",
          key: "total_project_cost",
          label: "Total Project Costs",
          attributes: {
            prepend: "£",
            default: 0,
            placeholder: "100,000",
            required: true,
            locked: true
          },
          validation: {
            min: 0,
            max: 250000
          },
          wrapper: {
            width: "1/3"
          }
        }
      }
    };
  },
  computed: {
    portalId() {
      let id = this.parentField;
      if (this.applicationValueIndex !== undefined) {
        id += "_" + this.applicationValueIndex;
      }
      return id;
    }
  },
  created() {
    Object.keys(this.applicationValue).map(key => {
      this.values[key] = this.applicationValue[key];
    });
  },
  methods: {
    updateField({ key, value }) {
      this.values[key] = parseFloat(value);
      return this.$emit("update:input", {
        parent: this.parentField,
        index: this.applicationValueIndex,
        key: this.input.key,
        value: {
          requested_grant: parseFloat(this.values.requested_grant),
          contribution: parseFloat(this.values.contribution),
          total_project_cost:
            parseFloat(this.values.requested_grant) +
            parseFloat(this.values.contribution)
        }
      });
    },
    getError(key) {
      if (!this.error) return;
      if (!this.error.hasOwnProperty(key)) return;
      return this.error[key];
    }
  }
};
</script>

<style>
.financial-summary .form-wrapper {
  @apply border-secondary-600;
}

.financial-summary .form-label,
.financial-summary .form-input-prefix,
.financial-summary .form-input-suffix,
.financial-summary .financial-summary-heading {
  @apply text-secondary-600;
}

.financial-summary .financial-summary-heading {
  @apply border-secondary-600 pb-1 pt-3 self-end text-secondary-600 text-right;
}

.financial-summary .financial-summary-heading p {
  @apply text-xs italic mb-1;
}

.financial-summary.has-error .form-label,
.financial-summary.has-error .form-input-prefix,
.financial-summary.has-error .form-input-suffix,
.financial-summary.has-error .financial-summary-heading,
.financial-summary.has-error .form-wrapper {
  @apply text-negative-600 border-negative-600;
}
</style>
